import Breadcrumbs from "@/components/breadcrumb";
import {Layout} from "@/components/layout";
import Container from "@/components/ui/container";
import {Separator} from "@/components/ui/separator";
import {HeadMetadata} from "@/components/headMetadata";
import React from "react";

export default function RadioPage() {
  const breadcrumb = [
    {label: 'Politique de confidentialité' }
  ];

  return (
    <Layout>
      <HeadMetadata
        title="Politique de confidentialité"
        description="Découvrez l'univers de RRB, où la musique rencontre la parole. Explorez nos dernières podcasts, trouvez nos fréquences et partez à la découverte de vos titres préférés."
      />

      <Container>
        <Breadcrumbs entries={breadcrumb}/>

        <h1 className="mb-2 text-[40px] text-foreground-dark">Politique de confidentialité</h1>
        <Separator className="mb-4"/>

        <div className="py-8 flex flex-col gap-4 max-w-[565px] mx-auto">
          <p><span>Bienvenue sur le site web de Radio Rythme Bleu en Nouvelle-Cal&eacute;donie. Nous accordons une grande importance &agrave; la confidentialit&eacute; de vos donn&eacute;es personnelles. Cette politique de confidentialit&eacute; explique quelles informations nous collectons, comment nous les utilisons et les prot&eacute;geons.</span></p>
          <h4><strong><span>1. Collecte des informations</span></strong></h4>
          <p><span>Nous collectons les informations personnelles suivantes :</span></p>
          <ul className="list-disc pl-8">
            <li>
              <p><strong><span>Donn&eacute;es d&apos;identification</span></strong><span>&nbsp;: Nom, pr&eacute;nom, adresse e-mail, num&eacute;ro de t&eacute;l&eacute;phone.</span></p>
            </li>
            <li>
              <p><strong><span>Informations de navigation</span></strong><span>&nbsp;: Adresse IP, type de navigateur, pages visit&eacute;es, temps de visite.</span></p>
            </li>
            <li>
              <p><strong><span>Informations fournies volontairement</span></strong><span>&nbsp;: Messages envoy&eacute;s via notre formulaire de contact, commentaires laiss&eacute;s sur nos articles, inscriptions &agrave; notre newsletter.</span></p>
            </li>
          </ul>
          <h4><strong><span>2. Utilisation des informations</span></strong></h4>
          <p><span>Les informations collect&eacute;es sont utilis&eacute;es pour :</span></p>
          <ul className="list-disc pl-8">
            <li>
              <p><span>Fournir et am&eacute;liorer nos services.</span></p>
            </li>
            <li>
              <p><span>Communiquer avec vous concernant nos services et actualit&eacute;s.</span></p>
            </li>
            <li>
              <p><span>R&eacute;pondre &agrave; vos questions et demandes.</span></p>
            </li>
            <li>
              <p><span>Personnaliser votre exp&eacute;rience sur notre site.</span></p>
            </li>
            <li>
              <p><span>Analyser et comprendre l&rsquo;utilisation de notre site.</span></p>
            </li>
          </ul>
          <h4><strong><span>3. Partage des informations</span></strong></h4>
          <p><span>Nous ne partageons vos informations personnelles qu&apos;avec :</span></p>
          <ul className="list-disc pl-8">
            <li>
              <p><span>Nos partenaires et prestataires de services dans le cadre de la fourniture de nos services (h&eacute;bergement, maintenance technique, etc.).</span></p>
            </li>
            <li>
              <p><span>Les autorit&eacute;s publiques lorsque la loi l&apos;exige.</span></p>
            </li>
          </ul>
          <h4><strong><span>4. S&eacute;curit&eacute; des informations</span></strong></h4>
          <p><span>Nous mettons en place des mesures de s&eacute;curit&eacute; appropri&eacute;es pour prot&eacute;ger vos informations personnelles contre toute perte, utilisation abusive, acc&egrave;s non autoris&eacute;, divulgation, alt&eacute;ration ou destruction.</span></p>
          <h4><strong><span>5. Cookies et technologies similaires</span></strong></h4>
          <p><span>Nous utilisons des cookies pour am&eacute;liorer votre exp&eacute;rience sur notre site. Les cookies sont de petits fichiers texte plac&eacute;s sur votre appareil pour collecter des informations standards de journal Internet et des informations sur le comportement des visiteurs. Vous pouvez configurer votre navigateur pour refuser les cookies, mais cela pourrait affecter certaines fonctionnalit&eacute;s de notre site.</span></p>
          <h4><strong><span>6. Vos droits</span></strong></h4>
          <p><span>Conform&eacute;ment &agrave; la r&eacute;glementation en vigueur, vous disposez des droits suivants :</span></p>
          <ul className="list-disc pl-8">
            <li>
              <p><strong><span>Droit d&apos;acc&egrave;s</span></strong><span>&nbsp;: Vous pouvez demander &agrave; acc&eacute;der aux informations personnelles que nous d&eacute;tenons sur vous.</span></p>
            </li>
            <li>
              <p><strong><span>Droit de rectification</span></strong><span>&nbsp;: Vous pouvez demander la correction des informations inexactes ou incompl&egrave;tes.</span></p>
            </li>
            <li>
              <p><strong><span>Droit &agrave; l&apos;effacement</span></strong><span>&nbsp;: Vous pouvez demander la suppression de vos informations personnelles.</span></p>
            </li>
            <li>
              <p><strong><span>Droit &agrave; la limitation du traitement</span></strong><span>&nbsp;: Vous pouvez demander la limitation du traitement de vos informations personnelles.</span></p>
            </li>
            <li>
              <p><strong><span>Droit d&apos;opposition</span></strong><span>&nbsp;: Vous pouvez vous opposer au traitement de vos informations personnelles.</span></p>
            </li>
            <li>
              <p><strong><span>Droit &agrave; la portabilit&eacute;</span></strong><span>&nbsp;: Vous pouvez demander &agrave; recevoir vos informations personnelles dans un format structur&eacute;, couramment utilis&eacute; et lisible par machine.</span></p>
            </li>
          </ul>
          <p><span>Pour exercer ces droits, veuillez nous contacter &agrave; rrb@lagoon.nc.</span></p>
          <h4><strong><span>7. Modifications de la politique de confidentialit&eacute;</span></strong></h4>
          <p><span>Nous pouvons modifier cette politique de confidentialit&eacute; de temps &agrave; autre. Toute modification sera affich&eacute;e sur cette page avec une date de mise &agrave; jour.</span></p>
          <h4><strong><span>8. Contact</span></strong></h4>
          <p><span>Pour toute question concernant cette politique de confidentialit&eacute;, veuillez nous contacter &agrave; :</span></p>
          <p>
            <span>Radio Rythme Bleu</span><br />
            <span>4 rue de S&eacute;bastopol Noum&eacute;a</span><br />
            <span>rrb@lagoon.nc</span>
          </p>
          <p><span>Date de mise &agrave; jour :&nbsp;</span></p>
          <p><span>22/07/2024</span></p>
        </div>
      </Container>
    </Layout>
  )
}

